import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const resourceExplorerViewsSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentResourceExplorerViews.select(
    {},
  );
